import { useState, useEffect, useMemo } from 'react';
import useBreakpoint from '../../hooks/useBreakpoint';
import '../style/CustomerDashboard.css';
//import { FloatingWhatsAppButton } from './../../whatsapp/components/WhatsAppComponents';
import Sidebar from './CustomerSidebar';
import { Menu, Loader, Code, Copy, Check, X } from "lucide-react";
import defaultCustomerLogo from "../../media/lisualLogo.jpg";
import { useNavigate, useParams } from "react-router-dom";
import { db } from '../../firebase-config';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ArrowRight, Info, Share2, Download, Settings, Pen } from 'lucide-react';
import CamConfig from './CamConfig.tsx';
import NotificationBell from '../../notifications/components/NotificationBell.tsx';
import NotificationPreferences from '../../notifications/components/NotificationPreferences.tsx';
import QRModal  from './QRModal.js';
import { getProjectsByCustomerId } from '../api/Customer.api.js';
import { getObras } from '../../obras/api/obras.api.js';
import { getSidebarConfig } from '../api/sidebarConfig.api.js';
import ProjectLastFrameImage from './ProjectLastFrameImage.js'; // Import the new component
import { getRotationDegrees, computeOrientedImageStyle } from '../../utils/cameraOrientation.js';
import useLisualWidget from '../../utils/useLisualWidget';
import NivelFidelidad from './NivelFidelidad.jsx';
import { isCamaraActiva } from '../../utils/camaraStatus';
import LinksPersonalizados from '../../linksPersonalizados/LinksPersonalizados';

function CustomerDashboard() {
  const { customerId } = useParams(); 
  const [projects, setProjects] = useState([]);
  const [obras, setObras] = useState([]);
  const [sidebarButtons, setSidebarButtons] = useState([]);
  const [selectedObraFilter, setSelectedObraFilter] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const [openLogoRequest, setOpenLogoRequest] = useState(0);
  const [logoSaved, setLogoSaved] = useState(false);
  const [showNotifPrefs, setShowNotifPrefs] = useState(false);
  const { isTablet, isDesktop } = useBreakpoint();
  // On tablets the sidebar is an overlay drawer, so start it closed
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isTablet);
  const [activeTab, setActiveTab] = useState("Inicio");
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [isLoadingCustomer, setIsLoadingCustomer] = useState(true);
  const [isLoadingProjects, setIsLoadingProjects] = useState(true);
  const [isLoadingLogo, setIsLoadingLogo] = useState(true);
  const [imageOrientations, setImageOrientations] = useState({});
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const [ftps3ImageUrls, setFtps3ImageUrls] = useState({}); // New state for FTPS3 pre-signed URLs
  const [imageRetryCounts, setImageRetryCounts] = useState({}); // State to track image retry attempts
  const MAX_IMAGE_RETRIES = 2; // Maximum number of retries for image loading
  const navigate = useNavigate();
  const [isCamConfigModalOpen, setIsCamConfigModalOpen] = useState(false);
  const [projectIdentifierToConfigure, setProjectIdentifierToConfigure] = useState(null);

  const [imageErrorStates, setImageErrorStates] = useState({});
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const [QRscanCustomerId, setQRscanCustomerId] = useState(null);
  const [QRscanIdentifier, setQRscanIdentifier] = useState(null);
  const [iframeModal, setIframeModal] = useState(null);
  const [copiedIframeId, setCopiedIframeId] = useState(null);

  const handleCloseQRModal = () => {
    setIsQRModalOpen(false);
  };

  const handleShowIframeCode = (project) => {
    if (!project.feedID) {
      toast.error("Este proyecto no tiene un FeedID configurado");
      return;
    }

    const baseUrl = window.location.origin;
    const iframeCode = `<iframe src="${baseUrl}/public-iframe?feedId=${project.feedID}&label=${encodeURIComponent(project.Name)}" width="100%" height="500" frameborder="0" allowfullscreen></iframe>`;
    const compareIframeCode = `<iframe src="${baseUrl}/public-compare?feedId=${project.feedID}&label=${encodeURIComponent(project.Name)}" width="100%" height="500" frameborder="0" allowfullscreen></iframe>`;
    const mondaysIframeCode = `<iframe src="${baseUrl}/public-mondays?feedId=${project.feedID}&label=${encodeURIComponent(project.Name)}" width="100%" height="500" frameborder="0" allowfullscreen></iframe>`;

    setIframeModal({
      project: project.Name,
      feedId: project.feedID,
      code: iframeCode,
      compareCode: compareIframeCode,
      mondaysCode: mondaysIframeCode
    });
  };

  const copyToClipboard = (text, key = true) => {
    navigator.clipboard.writeText(text);
    setCopiedIframeId(key);
    setTimeout(() => setCopiedIframeId(null), 2000);
    toast.success("Código copiado al portapapeles");
  };
    



  // === TOKEN DESDE URL (superUser accediendo desde admin) ===
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = searchParams.get("super");

    if (tokenFromUrl) {
      // Guardar token
      localStorage.setItem("authLisualToken", tokenFromUrl);

      // Limpiar la URL (saca el ?token)
      window.history.replaceState({}, document.title, window.location.pathname);

      console.log("🔐 Token superUser guardado desde URL");
    }
  }, []);

  const fetchSingleFtps3ImageUrl = async (projectId, feedID) => {
    ////console.log(`[CD] fetchSingleFtps3ImageUrl called for projectId: ${projectId}, feedID: ${feedID}`);
    const token = localStorage.getItem("authLisualToken");

    try {
      const response = await fetch(
          `https://webback.lisual.com/api/s3-images/${feedID}/latest`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
      );

      if (!response.ok) {
        console.error(`[CD] fetchSingleFtps3ImageUrl HTTP error for ${feedID}: ${response.status}`);
        throw new Error(`HTTP ${response.status}`);
      }

      let imageUrl = null;
      const clonedResponse = response.clone(); // Clone the response to read it twice if needed

      try {
        const data = await response.json();
        imageUrl = data?.url;
        ////console.log(`[CD] fetchSingleFtps3ImageUrl JSON response for ${feedID}:`, data);
      } catch (jsonError) {
        // If parsing as JSON fails, assume it's a plain text URL from the cloned response
        imageUrl = await clonedResponse.text();
        ////console.log(`[CD] fetchSingleFtps3ImageUrl Plain text response for ${feedID}:`, imageUrl);
      }
      
      if (imageUrl) {
        setFtps3ImageUrls((prev) => ({
          ...prev,
          [projectId]: imageUrl,
        }));

        // Explicitly set loading state to true to trigger image load in ProjectLastFrameImage
        setImageLoadingStates((prev) => ({
          ...prev,
          [projectId]: true,
        }));
        //console.log(`[CD] fetchSingleFtps3ImageUrl success for ${projectId}. imageUrl: ${imageUrl}`);
        return true;
      }
      //console.log(`[CD] fetchSingleFtps3ImageUrl no imageUrl in response for ${feedID}`);
      return false;
    } catch (error) {
      console.error(
          `[CD] Error fetching FTPS3 image URL for ${feedID}:`,
          error
      );
      return false;
    }
  };

  // Widget de ayuda: reconoce al usuario logueado (sin cámara puntual: el bot pregunta la obra).
  useLisualWidget({ customerId: customerId || "", customerName: customerData[0]?.name || "", customerPhone: customerData[0]?.mainUserPhone || "", ready: !!customerId && customerData.length > 0 });

  const fetchProjects = async () => {
    if (!customerId) return;
    //console.log("[CD] fetchProjects started for customerId:", customerId);

    try {

      const projectsData = await getProjectsByCustomerId(customerId);

      setProjects(projectsData);

      const initialLoadingStates = {};
      const newFtps3ImageUrls = {};
      const newRetryCounts = {};
      const newImageErrors = {};

      const token = localStorage.getItem("authLisualToken");

      for (const project of projectsData) {
        // Initialize all states to default (not loading, no error, no retries)
        initialLoadingStates[project.id] = false;
        newRetryCounts[project.id] = 0;
        newImageErrors[project.id] = false;

        // If no feedID, skip image logic
        if (!project?.feedID || project?.feedID === 'null') {
          //console.log(`[CD] Project ${project.id} has no feedID.`);
          continue;
        }

        // Set loading state to true while fetching the signed URL.
        initialLoadingStates[project.id] = true; 
        //console.log(`[CD] Project ${project.id} is FTPS3. Setting initialLoadingStates[${project.id}] to true (fetching signed URL).`);
        try {
          const response = await fetch(
              `https://webback.lisual.com/api/s3-images/${project.feedID}/latest`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
          );

          if (!response.ok) {
            console.error(`[CD] FTPS3 fetch HTTP error for ${project.feedID}: ${response.status}`);
            throw new Error(`HTTP ${response.status}`);
          }

          let imageUrl = null;
          const clonedResponse = response.clone(); // Clone the response to read it twice if needed

          try {
            const data = await response.json();
            imageUrl = data?.url;
            //console.log(`[CD] FTPS3 API JSON response for ${project.id}:`, data?.imageUrl ? "URL received" : "No URL received");
          } catch (jsonError) {
            // If parsing as JSON fails, assume it's a plain text URL from the cloned response
            imageUrl = await clonedResponse.text();
            //console.log(`[CD] FTPS3 API Plain text response for ${project.id}:`, imageUrl ? "URL received" : "No URL received");
          }

          if (imageUrl) {
            newFtps3ImageUrls[project.id] = imageUrl;
            // initialLoadingStates[project.id] remains true, as the image will now attempt to load this URL.
            //console.log(`[CD] FTPS3 Project ${project.id}: Signed URL obtained.`);
          } else {
            newImageErrors[project.id] = true;
            initialLoadingStates[project.id] = false; // No URL, so not loading, but in error state
            //console.log(`[CD] FTPS3 Project ${project.id}: No signed URL in response. Error state.`);
          }

        } catch (err) {
          console.error(`[CD] FTPS3 fetch error for ${project.feedID}:`, err);
          newImageErrors[project.id] = true;
          initialLoadingStates[project.id] = false; // Error fetching URL, so not loading, but in error state
        }
      }

      setFtps3ImageUrls(newFtps3ImageUrls);
      setImageRetryCounts(newRetryCounts);
      setImageErrorStates(newImageErrors);

      // Only update imageLoadingStates for projects that actually have a URL to load.
      // For FTPS3, this will be managed by the img tag's events.
      setImageLoadingStates((prev) => ({
        ...prev,
        ...initialLoadingStates,
      }));
      //console.log("[CD] fetchProjects completed. ftps3ImageUrls:", newFtps3ImageUrls);
      //console.log("[CD] fetchProjects completed. imageLoadingStates (initial):", initialLoadingStates);
      //console.log("[CD] fetchProjects completed. imageErrorStates (initial):", newImageErrors);


    } catch (error) {

      console.error("[CD] Error fetching projects:", error);
      toast.error("Error al cargar los proyectos.");

    } finally {

      setIsLoadingProjects(false);
      //console.log("[CD] setIsLoadingProjects(false)");

    }
  };

  useEffect(() => {
    if (customerId) {
      //console.log("[CD] useEffect: customerId changed, calling fetchProjects.");
      fetchProjects();
    }
  }, [customerId]);

  useEffect(() => {
    if (!customerId) return;
    getObras(customerId)
      .then((data) => setObras(data || []))
      .catch((error) => console.error("Error al obtener las obras:", error));
  }, [customerId]);

  useEffect(() => {
    if (!customerId) return;
    getSidebarConfig(customerId)
      .then((data) => setSidebarButtons(Array.isArray(data?.buttons) ? data.buttons : []))
      // The customer may not have a sidebar config yet (404): fall back to an empty list without breaking the screen.
      .catch(() => setSidebarButtons([]));
  }, [customerId]);

  const obraNombreById = useMemo(
    () => Object.fromEntries(obras.map((obra) => [obra.id, obra.nombre])),
    [obras]
  );

  // No need for Blob URL cleanup anymore

  useEffect(() => {
    const fetchCustomerData = async () => {
      if (!customerId) return;
      //console.log("[CD] fetchCustomerData started for customerId:", customerId)

      const q = query(collection(db, "customers"), where("customerId", "==", customerId));
      try {
        const querySnapshot = await getDocs(q);
        const customerData = [];
        querySnapshot.forEach((doc) => {
          customerData.push({ id: doc.id, ...doc.data() });
        });
        //console.log("[CD] customerData fetched:", customerData)
        setCustomerData(customerData);
      } catch (error) {
        console.error("[CD] Error fetching customer data:", error);
      } finally {
        setIsLoadingCustomer(false);
        //console.log("[CD] setIsLoadingCustomer(false)");
      }
    };
    if (customerId) {
      fetchCustomerData();
    }
  }, [customerId]); 

  useEffect(() => {
    //console.log("[CD] useEffect: isLoadingCustomer or isLoadingProjects changed. isLoadingCustomer:", isLoadingCustomer, "isLoadingProjects:", isLoadingProjects);
    if (!isLoadingCustomer && !isLoadingProjects) {
      setIsLoadingContent(false);
      //console.log("[CD] setIsLoadingContent(false)");
    } else {
      setIsLoadingContent(true);
      //console.log("[CD] setIsLoadingContent(true)");
    }
  }, [isLoadingCustomer, isLoadingProjects]);

  useEffect(() => {
    //console.log("[CD] useEffect: isLoadingCustomer changed. isLoadingCustomer:", isLoadingCustomer);
    if (!isLoadingCustomer) {
      setIsLoadingLogo(false);
      //console.log("[CD] setIsLoadingLogo(false)");
    }
  }, [customerData]); // Changed dependency to customerData to ensure logo loads when data is available


  const [customerAllowed, setCustomerAllowed] = useState(false);

  useEffect(() => {
    const allowedCustomers = ["tecpetrol05122025", "safiar15122025"];
    if (customerId && allowedCustomers.includes(customerId.toLowerCase())) {
      setCustomerAllowed(true);
    } else {
      setCustomerAllowed(false);
    }
  }, [customerId]);




  const [showFunnelUpForm, setShowFunnelUpForm] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSetActiveTab = (tabName) => {
    setActiveTab(tabName);
  };

  const handleIngresar = (identifier) => {
    //console.log(`[CD] Navigating to /dashboard/${identifier}`);
    navigate(`/dashboard/${identifier}`, '_blank');
  };

  const handleOpenCamConfigModal = (identifier) => {
    setProjectIdentifierToConfigure(identifier);
    setIsCamConfigModalOpen(true);
  };

  const handleOpenQRScan = (customerId, identifier) => {
    setIsQRModalOpen(true);
    setQRscanCustomerId(customerId);
    setQRscanIdentifier(identifier);
  };

  const handleCloseCamConfigModal = () => {
    setIsCamConfigModalOpen(false);
    setProjectIdentifierToConfigure(null);
  };

  const handleProjectUpdated = () => {
    //console.log("[CD] handleProjectUpdated: Refetching projects.");
    fetchProjects(); 
  };

  const handleImageLoad = (e, projectId) => {
    //console.log(`[CD] handleImageLoad for projectId: ${projectId}`);
    const img = e.target;
    const wrapper = img.parentElement;
    const rotationDeg = getRotationDegrees(projects.find(p => p.id === projectId)?.orientation);
    const orientation = computeOrientedImageStyle({
      rotationDeg,
      naturalWidth: img.naturalWidth,
      naturalHeight: img.naturalHeight,
      containerWidth: wrapper?.clientWidth || img.clientWidth,
      containerHeight: wrapper?.clientHeight || img.clientHeight,
    });
    setImageOrientations(prev => ({
      ...prev,
      [projectId]: orientation
    }));
    setImageLoadingStates(prev => ({
      ...prev,
      [projectId]: false
    }));
    setImageErrorStates(prev => ({ // Clear error state on successful load
      ...prev,
      [projectId]: false,
    }));
    setImageRetryCounts(prev => ({ // Reset retry count on successful load
      ...prev,
      [projectId]: 0,
    }));
  };

  const handleImageError = async (projectId, project) => {
    //console.log(`[CD] handleImageError for projectId: ${projectId}`);
    const currentRetries = imageRetryCounts[projectId] || 0;

    if (currentRetries < MAX_IMAGE_RETRIES) {

      setImageRetryCounts(prev => ({
        ...prev,
        [projectId]: currentRetries + 1
      }));

      //console.log(`[CD] FTPS3 image error for ${projectId}. Attempting to refetch signed URL.`);
      const success = await fetchSingleFtps3ImageUrl(
          projectId,
          project.feedID
      );

      if (success) {
        //console.log(`[CD] FTPS3 image error for ${projectId}. Refetch signed URL successful.`);
        return;
      }
    }

    setImageLoadingStates((prev) => ({
      ...prev,
      [projectId]: false,
    }));

    setImageErrorStates((prev) => ({
      ...prev,
      [projectId]: true,
    }));
    //console.log(`[CD] FTPS3 image error for ${projectId}. Max retries or refetch failed.`);
  };

  useEffect(() => {
    if (customerData.length > 0 && customerData[0].logo) {
      setIsLoadingLogo(false);
    }
  }, [customerData]);







  // Removed getProjectImageUrl from here as it's now in ProjectLastFrameImage.js

  // Avisos para el cliente que se muestran en la campanita; agregá nuevos acá
  const notices = [];
  if (customerData?.length > 0 && !customerData[0].logo && !logoSaved) {
    notices.push({
      key: "missing-logo",
      kind: "aviso",
      title: "Falta de logo",
      description: "Subí el logo de tu empresa",
      actionText: "Subir logo",
      onClick: () => setOpenLogoRequest((n) => n + 1),
    });
  }

  const bell = (
    <NotificationBell
      customerId={customerId}
      notices={notices}
      onOpenPreferences={() => setShowNotifPrefs(true)}
    />
  );

  return (
    <>



{/* FunnelUp Widget Toggle - Call Button */}
       
      



      <NotificationPreferences customerId={customerId} isOpen={showNotifPrefs} onClose={() => setShowNotifPrefs(false)} />

      <div className="flex h-dvh min-h-0 overflow-hidden bg-gray-100">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          activeTab={activeTab}
          setActiveTab={handleSetActiveTab}
          logo={customerData.length > 0 && customerData[0].logo ? customerData[0].logo : defaultCustomerLogo}
          isLoadingLogo={isLoadingLogo}
          customerId={customerId}
          onProjectCreated={fetchProjects}
          customerData={customerData}
          sidebarButtons={sidebarButtons}
          openLogoRequest={openLogoRequest}
          onLogoSaved={() => setLogoSaved(true)}
        />

        <div className="lg:hidden fixed top-0 left-0 right-0 z-30 bg-white border-b border-gray-200 shadow-sm">
          <div className="flex items-center justify-between px-4 py-3">
            {isLoadingLogo ? (
              <p className="text-center text-gray-500">Cargando...</p>
            ) : (
              customerData.length > 0 && customerData[0].logo ? (
                <img src={customerData[0].logo} alt="Logo" className="max-h-12 w-auto" />
              ) : (
                null
              )
            )}
            <div className="flex items-center gap-2 ml-auto">
              {!isDesktop && bell}
              <button
                onClick={toggleSidebar}
                className="p-2.5 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <Menu size={24} className="text-gray-600" />
              </button>
            </div>
          </div>
        </div>

        <div className={`flex-1 flex flex-col min-h-0 ${isSidebarOpen ? "lg:ml-64" : "lg:ml-0"}`}>
          {/*<FloatingWhatsAppButton message="Tengo una consulta." className="z-40" />*/}

          <main className="flex-1 min-h-0 w-full overflow-y-auto bg-gray-100 p-3 md:p-6 mt-14 lg:mt-0">
            {activeTab === "Link personalizados" ? (
              // En celular la barra de arriba es fija y tapa el principio del main (mismo espacio que deja el inicio con mt-16)
              <div className="h-full pt-16 lg:pt-0">
                <LinksPersonalizados customerId={customerId} />
              </div>
            ) : (
            <div className="dashboard-container">

            <div className="mt-16 dashboard-content">
              

              

              </div>

              {isLoadingContent ? (
                <div className="flex justify-center items-center h-full min-h-[300px]">
                  <Loader size={48} className="animate-spin text-blue-500" />
                </div>
              ) : (
                <>
                  <div className="cd-bienvenida">
                    <h1>
                      <strong>Bienvenido/a: </strong>{customerData[0]?.name ?? 'Cliente desconocido'}
                    </h1>
                    {isDesktop ? (
                      <div className="flex items-center gap-3">
                        <NivelFidelidad camaras={projects} />
                        {bell}
                      </div>
                    ) : (
                      <NivelFidelidad camaras={projects} />
                    )}
                  </div>


                  <br />

                  {obras.length > 0 && (
                    <div className="flex items-center gap-2 mb-4">
                      <label htmlFor="obra-filter" className="text-sm font-medium text-gray-700">Obras</label>
                      <select
                        id="obra-filter"
                        value={selectedObraFilter}
                        onChange={(e) => setSelectedObraFilter(e.target.value)}
                        className="border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white"
                      >
                        <option value="">Todas las obras</option>
                        {obras.map((obra) => (
                          <option key={obra.id} value={obra.id}>{obra.nombre}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="project-grid">
                    {projects
                      .filter(p => isCamaraActiva(p))
                      .filter(p => !selectedObraFilter || p.obra === selectedObraFilter)
                      .map((project) => (
                      <div key={project.id} className="project-card">
                        <div className={`project-image-wrapper ${imageOrientations[project.id]?.isVertical ? 'bg-black' : 'bg-white'}`}>
                      {!imageErrorStates[project.id] ? (
                        <ProjectLastFrameImage
                          project={project}
                          ftps3ImageUrls={ftps3ImageUrls}
                          imageLoadingStates={imageLoadingStates}
                          imageErrorStates={imageErrorStates}
                          imageOrientations={imageOrientations}
                          handleImageLoad={handleImageLoad}
                          handleImageError={handleImageError}
                          handleIngresar={handleIngresar}
                        />
                      ) : (
                        /* Renderiza un espacio vacío o un placeholder sutil si prefieres */
                        <div className="w-full h-full bg-gray-50" />
                      )}
                          <div className="project-title-overlay">
                            {project.Name}
                            {project.obra && obraNombreById[project.obra] && (
                              <> - <strong>{obraNombreById[project.obra]}</strong></>
                            )}
                          </div>
                        </div>
                        <div className="project-button-bar">
                          <div className="project-button-left">
                            <button onClick={() => handleIngresar(project.identifier)}>
                              <ArrowRight size={18} />
                            </button>
                          </div>

                          <div className="project-button-right">
                            <button
                              title="Obtener código del iframe"
                              onClick={() => handleShowIframeCode(project)}
                              className="p-2 rounded-full bg-purple-100 hover:bg-purple-500 transition-colors group"
                            >
                              <Code className="w-5 h-5 text-purple-600 group-hover:text-white" />
                            </button>

                            {project.pirAnalytics === true && (
                              <div className="relative flex items-center justify-center">
                                <button
                                  className="transition-all duration-300 hover:scale-110 active:scale-95 p-2 bg-blue-50 rounded-lg hover:bg-blue-100"
                                  onClick={() => navigate(`/dashboard/${project.identifier}`, { state: { initialTab: 'Dashboard IA' } })}
                                >
                                  <span className="text-sm font-bold text-blue-600">IA</span>
                                </button>
                              </div>
                            )}

                            {project.camaraUID ? (
                              <button onClick={() => handleOpenCamConfigModal(project.identifier)}>
                                <Pen size={18} />
                              </button>
                            ) : (
                              <button onClick={() => handleOpenQRScan(project.customerId, project.identifier)}>
                                <Settings size={18} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
            )}
          </main>
        </div>

        {/*<FloatingWhatsAppButton message="Tengo una consulta." />*/}
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {isCamConfigModalOpen && (
            <CamConfig
                isOpen={isCamConfigModalOpen}
                onClose={handleCloseCamConfigModal}
                onSave={handleProjectUpdated}
                projectIdToEdit={projectIdentifierToConfigure} 
                customerId={customerId} 
            />
        )}


        {/* QR Modal */}
        {isQRModalOpen && (
          <QRModal
            isOpen={isQRModalOpen}
            onClose={handleCloseQRModal}
            customerId={QRscanCustomerId}
            identifier={QRscanIdentifier}
          />
        )}

        {/* Iframe Code Modal */}
        {iframeModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75 backdrop-blur-sm">
            <div className="relative bg-white dark:bg-gray-900 rounded-2xl overflow-hidden max-w-2xl w-full shadow-2xl">
              <button
                onClick={() => setIframeModal(null)}
                className="absolute top-4 right-4 p-2 bg-black bg-opacity-50 text-white rounded-full hover:bg-opacity-70 transition-all z-10"
              >
                <X className="w-6 h-6" />
              </button>

              <div className="p-6 border-b border-gray-200 dark:border-gray-700">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white">Código del iframe</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                  Proyecto: <span className="font-semibold">{iframeModal.project}</span>
                </p>
              </div>

              <div className="p-6 bg-gray-50 dark:bg-gray-800 space-y-6">
                <div>
                  <p className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Cámara en vivo</p>
                  <div className="relative">
                    <pre className="bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto text-sm font-mono">
                      <code>{iframeModal.code}</code>
                    </pre>
                    <button
                      onClick={() => copyToClipboard(iframeModal.code, "live")}
                      className="absolute top-3 right-3 p-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors flex items-center gap-2"
                    >
                      {copiedIframeId === "live" ? (
                        <>
                          <Check className="w-4 h-4" />
                          <span className="text-xs">Copiado</span>
                        </>
                      ) : (
                        <>
                          <Copy className="w-4 h-4" />
                          <span className="text-xs">Copiar</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>

                <div>
                  <p className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Comparador antes / después</p>
                  <div className="relative">
                    <pre className="bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto text-sm font-mono">
                      <code>{iframeModal.compareCode}</code>
                    </pre>
                    <button
                      onClick={() => copyToClipboard(iframeModal.compareCode, "compare")}
                      className="absolute top-3 right-3 p-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors flex items-center gap-2"
                    >
                      {copiedIframeId === "compare" ? (
                        <>
                          <Check className="w-4 h-4" />
                          <span className="text-xs">Copiado</span>
                        </>
                      ) : (
                        <>
                          <Copy className="w-4 h-4" />
                          <span className="text-xs">Copiar</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>

                <div>
                  <p className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Timelapse de lunes</p>
                  <div className="relative">
                    <pre className="bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto text-sm font-mono">
                      <code>{iframeModal.mondaysCode}</code>
                    </pre>
                    <button
                      onClick={() => copyToClipboard(iframeModal.mondaysCode, "mondays")}
                      className="absolute top-3 right-3 p-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors flex items-center gap-2"
                    >
                      {copiedIframeId === "mondays" ? (
                        <>
                          <Check className="w-4 h-4" />
                          <span className="text-xs">Copiado</span>
                        </>
                      ) : (
                        <>
                          <Copy className="w-4 h-4" />
                          <span className="text-xs">Copiar</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="p-4 bg-blue-50 dark:bg-blue-900/20 border-t border-gray-200 dark:border-gray-700">
                <p className="text-sm text-blue-900 dark:text-blue-200">
                  💡 <span className="font-semibold">Tip:</span> Ajusta el ancho (<code>width</code>) y alto (<code>height</code>) según necesites en tu sitio web.
                </p>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default CustomerDashboard;